import { render } from "./ItemDescription.vue?vue&type=template&id=1d366137&scoped=true"
import script from "./ItemDescription.vue?vue&type=script&lang=js"
export * from "./ItemDescription.vue?vue&type=script&lang=js"

import "./ItemDescription.vue?vue&type=style&index=0&id=1d366137&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d366137"]])

export default __exports__